export const NEWSMTP = 'NEWSMTP';
export const DELETESMTP = 'DELETESMTP';
export const UPDATESMTP = 'UPDATESMTP';
export const CONTROLSMTP = 'CONTROLSMTP';
export const ONECONTROLSMTP = 'ONECONTROLSMTP';
export const SHOW_LOADING = 'SHOW_LOADING'